// extracted by mini-css-extract-plugin
export default {"home__insoles_section":"HomeInsoles_home__insoles_section__12M-Y","container":"HomeInsoles_container__bddRs","home__insoles_wrapper":"HomeInsoles_home__insoles_wrapper__ymYtI"};